/* SNZ-OTHER-COLOUR (19 Oct 2026)
   Product pages: when the shopper picks the "Other (Custom Colour)" swatch, ask which colour
   they want. The answer travels as the visible line property "Requested colour" through the bag,
   checkout, the order and the confirmation email. Add to cart waits until it is filled in.
   Buy it now / express buttons are hidden while Other is selected, because they skip this check.
   The builder (custom-bed-bundle-parent) is left alone: it lists its colours in Order Details. */
(function () {
  if (window.__snzOtherColour) return;
  window.__snzOtherColour = true;

  var OTHER = /^other(\s+colou?r)?\s*\(/i;
  var PROP = 'properties[Requested colour]';
  var otherIds = null;
  var setUp = typeof WeakSet === 'function' ? new WeakSet() : null;

  function productHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function injectStyles() {
    if (document.getElementById('snz-oc-style')) return;
    var s = document.createElement('style');
    s.id = 'snz-oc-style';
    s.textContent =
      '.snz-oc{margin:0 0 1.6rem}' +
      '.snz-oc[hidden]{display:none!important}' +
      '.snz-oc .field{margin:0}' +
      '.snz-oc__hint{margin:.8rem 0 0;font-size:1.25rem;line-height:1.5;color:rgba(var(--color-foreground),.72)}' +
      '.snz-oc__err{margin:.8rem 0 0;font-size:1.25rem;line-height:1.5;color:#9B2C2C}' +
      '.snz-oc__err[hidden]{display:none}' +
      '.snz-oc.is-invalid .field__input{box-shadow:0 0 0 .1rem #9B2C2C}';
    document.head.appendChild(s);
  }

  function idInput(form) {
    return form.querySelector('input[name="id"], select[name="id"]');
  }

  function paymentButtons(form) {
    var scope = form.closest('product-info, .product, section') || form.parentElement;
    return [].slice.call(scope.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout'));
  }

  function setup(form) {
    if (setUp ? setUp.has(form) : form.__snzOC) return;
    if (setUp) setUp.add(form); else form.__snzOC = true;

    var uid = 'SnzOC-' + Math.random().toString(36).slice(2, 8);
    var wrap = document.createElement('div');
    wrap.className = 'snz-oc';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="field">' +
        '<input class="field__input" type="text" id="' + uid + '" name="' + PROP + '" maxlength="80"' +
        ' placeholder=" " autocomplete="off" aria-describedby="' + uid + '-hint" disabled>' +
        '<label class="field__label" for="' + uid + '">Which colour would you like?</label>' +
      '</div>' +
      '<p class="snz-oc__hint" id="' + uid + '-hint">Name any colour, for example one from our colour chart. It is saved with your order.</p>' +
      '<p class="snz-oc__err" role="alert" hidden>Tell us the colour you would like first.</p>';

    var input = wrap.querySelector('input');
    var err = wrap.querySelector('.snz-oc__err');
    var buttons = form.querySelector('.product-form__buttons');
    if (buttons && buttons.parentNode === form) form.insertBefore(wrap, buttons);
    else form.insertBefore(wrap, form.firstChild);

    function isOther() {
      var el = idInput(form);
      return !!(el && otherIds[String(el.value)]);
    }

    function sync() {
      var on = isOther();
      wrap.hidden = !on;
      input.disabled = !on;
      if (!on) {
        err.hidden = true;
        wrap.classList.remove('is-invalid');
      }
      paymentButtons(form).forEach(function (b) {
        b.style.display = on ? 'none' : '';
      });
    }

    input.addEventListener('input', function () {
      if (input.value.trim()) {
        err.hidden = true;
        wrap.classList.remove('is-invalid');
      }
    });

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') sync();
    });

    form.__snzOCCheck = function (e) {
      if (!isOther()) return;
      input.value = input.value.trim();
      if (input.value) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      err.hidden = false;
      wrap.classList.add('is-invalid');
      input.focus();
    };
    form.__snzOCSync = sync;
    sync();
  }

  function scan() {
    if (!otherIds) return;
    [].slice.call(document.querySelectorAll('product-form form[action*="/cart/add"]')).forEach(function (f) {
      setup(f);
      if (f.__snzOCSync) f.__snzOCSync();
    });
  }

  // Runs before Dawn's own submit handler on the form, so an empty request never reaches the cart.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && typeof f.__snzOCCheck === 'function') f.__snzOCCheck(e);
  }, true);

  function init() {
    var h = productHandle();
    if (!h || h === 'custom-bed-bundle-parent' || document.querySelector('[data-snz-bundle-root]')) return;
    if (!document.querySelector('product-form form[action*="/cart/add"]')) return;

    fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        var ids = {}, any = false;
        p.variants.forEach(function (v) {
          if ((v.options || []).some(function (o) { return OTHER.test(String(o || '')); })) {
            ids[String(v.id)] = true;
            any = true;
          }
        });
        if (!any) return;
        otherIds = ids;
        injectStyles();
        scan();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(scan, 0); });
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
